import { Loader2 } from "lucide-react";

/** Accessible loading state for lazy routes and initial page requests. */
export default function PageLoading({ label = "Loading page" }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" className="flex min-h-[240px] items-center justify-center gap-3 bg-background p-6 text-foreground">
      <Loader2 aria-hidden="true" className="h-6 w-6 animate-spin text-primary" />
      <span>{label}</span>
    </div>
  );
}
